
import Component from 'vue-class-component';
import moduleStore from '../../store';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import PageState from '../../store/state';

// components
import { MAudio } from '@/utils/audio';
import { judgeDeviceType } from "@/utils/device";

// icon
import ownIcon from "@/assets/images/yiyongyou.svg";
import paidIcon from "@/assets/images/fufei.svg";
import memberIcon from "@/assets/images/huiyuan.svg";
import { Watch,Prop } from "vue-property-decorator"
import { VOICE_AUTH_TYPE } from "@/constants/voice";
import { VIP_TYPE } from "@/constants/vip"
import {FOREIGN} from '@/constants/constData'
import infiniteScroll from "@/components/infinite-scroll";
import { customCollectEvent } from '@/utils/collect';

/**components**/
@Component({
	components: {},
	computed: mapGetters(['getVoiceStatus']),
    directives: { infiniteScroll },
})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class speakerPopupComponent extends Vue {
    @Prop() getDefaultSpeakerKey: any;
	state: any = null;

	lastSelectSpeaker: any = null;//上次选中
	currentPlaySpeaker: any = null; // 当前选中 
	validateSpeaker: (data: { speaker: any }) => boolean = null;
	validateSpeakerAutoMute: boolean = false // 是否校验多发音人支持智能分句
	// currentSpeakerListId: any = null;
	speakerAudioPaused: boolean = true;
	// 搜索关键词
	searchKeywords: string = '';
	// 搜素结果
	searchResult: any[] = [];
	// tab弹出层显隐
	popupTabShow: boolean = false;
	// 选择tab index
	tabIndex: number = 0;
	isIOS = judgeDeviceType.isIOS;
	iosAppPop = false;
  	currentIdx: any = null;
	showSpeakerDataList: any = [];
	finished: boolean = true;
	loading:boolean= false;	
	getVoiceStatus: Function;
	curSpeakerList: any[] = [];
    userSpeakerTypeMapList: any = []; //用户发音人分类（"常用/已购/收藏"）
    speakerTypeIndex: number = 0; //用户发音人分类下标
    speakerTypeName: string = '热榜'; //用户发音人分类名称 热榜=热榜排序
    searchTagList: any = []; //分类目录
    selectedSearchTagIndex: number = 0; // 资费方式下标
    subSearchTagList: any = []; // 二级部分的查询条件(一级对应的领域)
    selectedSubSearchTagIndex: number = 0; // 二级查询条件index
    selectedSubSearchTagName: string = '全部'; //二级查询条件名称 -不要用index对应关系 因为不同资费方式 领域会变
    languageList: any = []; //所有外语
    selectedLanSearchTagIndex: number = 0; //语言二级查询条件index
    forEignLan: any = '全部'; //外语查询条件
    showTabUp: boolean = false;
    spkPage: number = 1; //当前页码
    allpages: number = 1; //总页数
    allSpeakersList: any = []; //所有发音人
    gender: any = 'ALL'; //发音人性别
    genderList: any = [
        { name: '全部性别', value: 'ALL' },
        { name: '男声', value: 'MALE' },
        { name: '女声', value: 'FEMALE' },
    ];
    isDragging: boolean = false; //是否在拖动
    // 鼠标位置
    mouseX: number = 0;
    mouseY: number = 0;
	@Watch('state.searchTagList')
    changeShowSpeakerDataList() {
        this.initSelectedSearchTagIndex();
    }
    @Watch('state.userSpeakerTypeMapList')
    changeUserSpeakerTypeMapList() {
        this.initUserSpeakerTypeMapList();
    }
	getVoiceStatusIcon(sItem) {
		const { owned, isPaidVoice } = this.getVoiceStatus(sItem)
		return owned ? ownIcon : isPaidVoice ? paidIcon : memberIcon
	}

	created(moduleData: IinjectDatas) {
		this.state = <PageState>moduleData.state;
    	let href = location.href
		if(href.indexOf('source=app')!=-1){
			this.iosAppPop = true;
		}
		console.log('---this.',this.iosAppPop);
	}

	mounted() {
		this.listenerAudio();
	}

	speakerAudio = null;
	myAudioPause: boolean = false;
    dragImg(e) {
        e.stopPropagation();
        e.preventDefault();
    
        let vm = this;
        let startTime = new Date().getTime();
        let target: any = vm.$refs.tabUpRef;
        let imgWidth = target.offsetWidth;
        let formHeight = (vm.$refs.formRef as any).offsetHeight;
        let winHeight = window.innerHeight;
        let winWidth = window.innerWidth;
        let topPx = winHeight * 0.1 + formHeight; //到顶
        let bottomPx = winHeight - imgWidth; //到底 屏幕高度 - 图片高度
        let rightPx = winWidth - imgWidth; //到右
    
        const currentTouch = e.touches[0];
        // 计算鼠标的相对坐标
        vm.mouseX = currentTouch.clientX - target.offsetLeft;
        vm.mouseY = currentTouch.clientY - target.offsetTop;
        /**
         * 鼠标移动事件
         * @param {*} event 鼠标信息
         */
        const onMove = event => {
          // 阻止冒泡
          event.stopPropagation();
          vm.isDragging = true;
          let currentTouch1 = event.touches[0];
          //   // 只处理 position 中的 left & top
          let top = currentTouch1.clientY - vm.mouseY;
          let left = currentTouch1.clientX - vm.mouseX;
          if (top < topPx) {
            top = topPx;
          } else if (top > bottomPx) {
            top = bottomPx;
          }
          if (left < 0) {
            left = 0;
          } else if (left > rightPx) {
            left = rightPx;
          }
          // 正常情况
          target.style.top = `${top}px`;
          target.style.left = `${left}px`;
        };
        /**
         * 鼠标事件
         * @param {*} event 鼠标信息
         */
        const onEnd = event => {
          vm.isDragging = false;
          let endTime = new Date().getTime();
          // 阻止冒泡
          event.stopPropagation();
          document.removeEventListener('touchmove', onMove);
          document.removeEventListener('touchend', onEnd);
          if (endTime - startTime < 500 && !vm.isDragging) {
            //500毫秒是长按 -不回顶部
            vm.scrollToTop();
            //可能还在滚动-再设置一次
            setTimeout(() => {
                vm.scrollToTop();
            },50)
          }
        };
        document.addEventListener('touchmove', onMove);
        document.addEventListener('touchend', onEnd);
    }
    getScroll() {
        let timer = null;
        let vm = this;
        if (timer) {
          clearTimeout(timer);
        }
    
        timer = setTimeout(function () {
          let ref: any = vm.$refs.scrollContentRef;
          let formHeight = (vm.$refs.formRef as any).offsetHeight;
          //第一个页面的高度-当前屏幕高度的80% -100px(顶部固定)
          let firstHeight = window.innerHeight * 0.9 - formHeight;
          if (ref.scrollTop > firstHeight) {
            vm.showTabUp = true;
          } else {
            vm.showTabUp = false;
          }
        }, 800);
    }
      // 选择初始声音类别
  initSelectedSearchTagIndex() {
    if (this.state.searchTagList.length > 0) {
      this.searchTagList = this.state.searchTagList;
      this.tagSearch(this.selectedSearchTagIndex);
    }
  }
  initUserSpeakerTypeMapList() {
    if (Object.keys(this.state.userSpeakerTypeMapList).length > 0) {
      // + "热榜排序(全部)"
      this.userSpeakerTypeMapList['热榜'] = [];
      this.userSpeakerTypeMapList = {
        ...this.userSpeakerTypeMapList,
        ...this.state.userSpeakerTypeMapList,
      };
    }
  }
    //资费方式选择
    tagSearch(index) {
        this.spkPage = 1;
        this.selectedSearchTagIndex = index;
        this.subSearchTagList = this.searchTagList[this.selectedSearchTagIndex].mediaSpeakerListVOList;
        this.querySpeakerListCache();
      }
      selectGender(gender) {
        this.gender = gender;
        this.spkPage = 1;
        this.querySpeakerListCache();
      }
      typeChange(item, index) {
        this.speakerTypeName = item;
        this.speakerTypeIndex = index;
        this.spkPage = 1;
        this.querySpeakerListCache();
      }
      subTagSearch(index, item?) {
        this.selectedSubSearchTagIndex = index;
        this.selectedSubSearchTagName = item.name;
        this.spkPage = 1;
        this.querySpeakerListCache();
      }
      querySpeakerListCache() {
        if (this.spkPage == 1) {
          this.showTabUp = false;
        }
        let EnNameArr = [];
        //选择的分类类型
        if (this.speakerTypeName != '热榜') {
          //热榜=热榜排序=全部
          if (this.speakerTypeName != '常用' && this.speakerTypeName != '最近'&&this.speakerTypeName != '历史') {
            EnNameArr = this.userSpeakerTypeMapList[this.speakerTypeName];
          } else {
            // 常用和最近返回格式是对象 -只取speaker字段
            //2024-07-26发现多了历史选项 也是对象
            EnNameArr =
              (this.userSpeakerTypeMapList[this.speakerTypeName] &&
                this.userSpeakerTypeMapList[this.speakerTypeName].map(v => v.speaker)) ||
              [];
          }
        }
        // 关键词搜索
        let arr = Object.keys(this.state.nameToEngNameMap).filter(
          v => v.toLowerCase().includes(this.searchKeywords.toLowerCase()) //输入的内容转化为小写
        );
    
        let speakersEnNameList = [];
        arr.map(v => {
          if (this.state.nameToEngNameMap[v]) {
            speakersEnNameList.push(this.state.nameToEngNameMap[v]);
          }
        });
    
        // tag 搜索
        let allSpeakersEnNameList = [];
    
        let subTag = this.subSearchTagList[this.selectedSubSearchTagIndex];
        allSpeakersEnNameList = subTag.speakerList || [];
        // 做一个本地分页 50条一页
        if (this.spkPage == 1) {
          this.allpages = Math.ceil(
            allSpeakersEnNameList.filter(v => speakersEnNameList.includes(v)).length / 54
          );
        }
    
        let result = [];
        //1.从声音商店分类查找
        if (this.speakerTypeName != '热榜') {
          //排序类型不是热榜排序(热榜即为全部)
          result = allSpeakersEnNameList.filter(v => {
            return (
              this.__isContainSpeaker(speakersEnNameList, v) && this.__isContainSpeaker(EnNameArr, v)
            );
          });
        } else {
          result = allSpeakersEnNameList.filter(v => this.__isContainSpeaker(speakersEnNameList, v));
        }
        //2.没有资费/领域/语言查找条件时 从"我的"中查找
        if (
          this.selectedSearchTagIndex == 0 &&
          this.selectedSubSearchTagIndex == 0 &&
          this.forEignLan == '全部'
        ) {
          let resultFromMy = [];
          let mySpeakerList = this.userSpeakerTypeMapList['我的'];
          if (EnNameArr && EnNameArr.length > 0) {
            resultFromMy = EnNameArr.filter(v => {
              return this.__isContainSpeaker(mySpeakerList, v);
            });
            result = result.concat(resultFromMy);
          }
        }
    
        
        let speakersList = this.__genSortedSpeakers(result);
        speakersList=speakersList.filter(item=>{
          return item.speaker
        })
        this.allSpeakersList = speakersList;
        if (this.gender === 'ALL' && this.forEignLan == '全部') {
          speakersList = speakersList.slice((this.spkPage - 1) * 54, this.spkPage * 54);
        } else {
          if (this.gender != 'ALL') {
            speakersList = speakersList.filter(item => item.gender === this.gender);
          }
          if (this.forEignLan != '全部') {
            speakersList = speakersList.filter(item => item.specificLanguage === this.forEignLan);
          }
    
          speakersList = speakersList.slice((this.spkPage - 1) * 54, this.spkPage * 54);
        }
        this.searchResult = this.spkPage == 1 ? speakersList : [...this.searchResult, ...speakersList];
      }
      //判断某个列表中是否包含指定发音人
      __isContainSpeaker(speakersList, speakerName) {
        let n_speakerName = '';
        if (speakerName.indexOf('_meet') != -1) {
          n_speakerName = speakerName.replace('_meet', '_lpcnet');
        } else {
          n_speakerName = speakerName.replace('_lpcnet', '_meet');
        }
        return speakersList.includes(speakerName) || speakersList.includes(n_speakerName);
      }
      loadMore() {
        this.spkPage = this.spkPage + 1;
        if (this.spkPage > this.allpages) {
          return;
        }
        this.querySpeakerListCache();
      }
      scrollToTop() {
        const list: any = this.$refs.scrollContentRef;
        if (list) {
          list.scrollTop = 0;
        }
        this.showTabUp = false;
      }
      handleLanguage(list) {
        list = list.filter(item => FOREIGN.includes(item.value));
        list.unshift({
          value: '全部',
          name: '全部',
        });
        return list;
      }
      showListByLan(index, item) {
        this.forEignLan = item.value;
        this.selectedLanSearchTagIndex = index;
        this.spkPage = 1;
        this.querySpeakerListCache();
      }
      // 根据发音人key list, 获取排序后的发音人列表
      __genSortedSpeakers(speakersList = []) {
        let list = [];
        speakersList.forEach(key => {
          if (typeof key === 'string' && key.includes('@')) {
            key = key.split('@')[0];
          }
          key = this.getDefaultSpeakerKey(key);
          let speakerMap = this.state.allSpeakersMap[key];
          if (!speakerMap) {
            return;
          }
          let speaker = speakerMap.default || {};
          speaker.disabled =
            speaker.vipAuth === VOICE_AUTH_TYPE.SVIP && this.state.vipInfo.type === VIP_TYPE.VIP;
          speaker.isLimitTimeFree = speaker.tags && speaker.tags.indexOf('免费') > -1;
          list.push(speaker);
        });
        return [...new Set(list)];
      }
	listenerAudio() {
		let self = this;
		if (!this.speakerAudio) {
			this.speakerAudio = MAudio.listen({
				playing: () => {
					console.log('playing');
					self.speakerAudioPaused = false;
					self.myAudioPause = false;
				},
				pause: () => {
					console.log('pause');
					self.myAudioPause = true;
				},
				ended: () => {
					console.log('ended');
					self.speakerAudioPaused = true;
					self.myAudioPause = false;
				}
			});
		}
	}

	async confirmSpeaker() {
		const $editor: any = this.$parent;
		// 校验多发音人 智能分句
		if (
			this.validateSpeakerAutoMute &&
			!(await $editor.validateAutoMute({
				speaker: this.currentPlaySpeaker
			}))
		) {
			return false;
		}
		if (!this.validateSpeaker || await this.validateSpeaker({
			speaker: this.currentPlaySpeaker
		})) {
			this.switchSpeaker()
		}
	}
	switchSpeaker() {
		this.state.speakerPopupVisible = false
		this.speakerAudio.stop()

		// 发音人发生改变
		if (this.currentPlaySpeaker && this.currentPlaySpeaker !== this.lastSelectSpeaker) {
			this.resolve({
				speaker: this.currentPlaySpeaker,
				index: this.currentIdx
			})
		} else {
			this.reject('NotChange')
		}
	}

	speakerPopupHide() {
		this.state.speakerPopupVisible = false;
		this.reject('Canceled')
	}
	onLoad(){
		this.querySpeakerListCache();
	}

	selectSpeaker(item: any, index: any) {
		if(this.speakerAudioPaused==false){
			this.speakerAudio.stop()
			this.speakerAudioPaused=true
		}
		this.currentPlaySpeaker = item;
		
		let params = {
			speakerId: item.id
		};
		this.$http('getSpeakerInfo', params).then((res: any) => {
			let data = res.data;
			if (data && data.demoUrl && this.state.speakerPopupVisible) {
				this.speakerAudio.setSrc(data.demoUrl);
				this.speakerAudio.play();
			} else {
				this.speakerAudio.stop();
				this.speakerAudio.setSrc('');
				// Toast.fail({
				// 	message: '播放链接不存在'
				// });
			}
		});
		this.currentIdx = index
		customCollectEvent('editor_voicepopup_play', {
			'articleid': this.state.articleId
		})
	}
	speakerPause(e) {
		if (this.myAudioPause == true) {
			this.speakerAudio.play()
			e.stopPropagation()
		} else {
			this.speakerAudio.pause()
			e.stopPropagation()
		}
	}
	letUserToVoiceShop(item: any) {
		// 如果是付费且未购买的声音则引导去声音商店购买
		console.log('letUserToVoiceShop', item);
		let speakerName = item.name.split('|')[0];
		let speakerEnName = item.speaker.split('@')[0];
		let speakerEmotionCount = 0;
        //todo 无 speakerList
        let result = [];
        const allSpeakerList = this.state.allSpeakersMap;
        let keys = Object.keys(allSpeakerList) || []; //所有发音人key
        for (let z = 0; z < keys.length; z++) {
            let speaker = allSpeakerList[keys[z]].default;
            if (speaker && speaker['usable']) {
                if(speaker.id == 999){
                    result.push(speaker)
                }
            }
        }
		let speakers = result.length ? result[0].speakers : [];
		let count = speakers.filter((res: any) => res.speaker.indexOf(speakerEnName) > -1);
		speakerEmotionCount = count.length;
		let obj = {
			name: speakerName,
			styleCount: speakerEmotionCount,
			tags: item.tags,
			speaker: item.speaker
		};

		this.state.selectPaySpeaker = obj;
		this.state.buyVoicePopupVisible = true;
	}


	catchTap() {

	}

	closeCallback() {
		this.reject('Canceled');
		this.searchKeywords = '';
		this.searchResult = [];
		if(this.speakerAudio) {
			this.speakerAudio.stop();
			this.speakerAudio.setSrc('');
		}
	}

	// 搜索操作
	enterSearchAction(){
        this.querySpeakerListCache();
	}

	clearSearchResult() {
		this.searchKeywords = '';
		// this.searchResult = [];
        this.querySpeakerListCache();
	}

	//todo 无 speakerList
	setDataSpeakerData(item = this.state.speakerList[0]) {
		if (item) {
			this.showSpeakerDataList = item.speakers.slice(0, 32);
			if (item.speakers.length <= 32) {
				this.finished = true
			}else{
				this.finished = false
			}
		}
	}

	// 打开popper调用
	_resolve: Function | null = null;
	_reject: Function | null = null;
	resolve(result: { speaker: any, index: number }) {
		this._resolve?.(result)
	}
	reject(reason: string) {
		this._reject?.(reason)
	}
	open({ speaker, validateSpeaker = null, validateSpeakerAutoMute = false }) {
		this.lastSelectSpeaker = speaker;
		this.currentPlaySpeaker = speaker;
		this.validateSpeaker = validateSpeaker
		this.validateSpeakerAutoMute = validateSpeakerAutoMute
		const p = new Promise((resolve, reject) => {
			this._resolve = resolve;
			this._reject = reject;
		})
		if (!this.state.isLogined) {
			const $editor: any = this.$parent
			$editor.saveArticleToLocal()
			setTimeout(() => $editor.gotoLogin(), 500)
			this.reject('NotLogin')
			return p
		}
		this.state.speakerPopupVisible = true
		this.tabIndex=0
		this.initSelectedSearchTagIndex()
		
		return p
	}
}
